import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const CTASection: React.FC = () => {
  return (
    <section className="relative py-24 bg-[#0F172A] overflow-hidden">
      {/* Abstract Background */}
      <div className="hidden lg:block absolute top-0 right-0 w-[600px] h-[600px] bg-primary/20 rounded-full blur-[120px] mix-blend-screen opacity-20 pointer-events-none" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-8">
        
        <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight leading-tight">
          You've Met The Team. <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-400 to-accent-400">
            Now Let's Get To Work.
          </span>
        </h2>
        
        <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed">
          The team you just read about is ready to audit your workflows and build your automation roadmap.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Link to="/contact">
            <Button
              variant="default"
              size="lg"
              iconName="Calendar"
              className="w-full sm:w-auto bg-white text-slate-900 hover:bg-slate-100 border-0"
            >
              Schedule Consultation
            </Button>
          </Link>
          <Link to="/case-studies">
            <Button
              variant="outline"
              size="lg"
              iconName="ArrowRight"
              className="w-full sm:w-auto border-slate-600 text-white hover:bg-white/10"
            >
              See Our Results
            </Button>
          </Link>
        </div>

        <p className="text-sm text-slate-500 pt-8">
          Trusted by growing businesses • Satisfaction Guarantee
        </p>
      </div>
    </section>
  );
};

export default CTASection;